import ButtonDetails from './ButtonDetails';

export default ButtonDetails;
